<template>
    <div class="py-4 px-3">
        <div class="row justify-content-center">
            <div class="col-md-8 col-lg-6">

                <!-- =====================================================
                     STATO: 2FA NON ATTIVO
                ====================================================== -->
                <div v-if="!twoFactorAbilitato && stepSetup === 'idle'">
                    <div class="text-center mb-4">
                        <i class="fa fa-shield-alt fa-4x text-muted mb-3"></i>
                        <h4>Autenticazione a due fattori</h4>
                        <p class="text-muted">
                            Il 2FA aggiunge un secondo livello di sicurezza al tuo account.<br>
                            Ad ogni login ti verrà chiesto un codice generato dall'app
                            <strong>Microsoft Authenticator</strong> o <strong>Google Authenticator</strong>
                        </p>
                        <button @click="avviaSetup" class="btn btn-primary btn-lg mt-2">
                            <i class="fa fa-plus-circle mr-1"></i> Abilita 2FA
                        </button>
                    </div>
                </div>

                <!-- =====================================================
                     SETUP STEP 1: mostra QR code e secret
                ====================================================== -->
                <div v-if="stepSetup === 'qr'">
                    <h5 class="mb-3"><i class="fa fa-qrcode mr-1"></i> Scansiona il QR code</h5>
                    <ol class="mb-4">
                        <li>Apri <strong>Microsoft Authenticator</strong> o <strong>Google Authenticator</strong> sul tuo telefono.</li>
                        <li>Tocca <strong>"+"</strong> e scegli <em>"Scansiona codice QR"</em>.</li>
                        <li>Scansiona il codice qui sotto, poi inserisci il codice a 6 cifre generato.</li>
                    </ol>

                    <!-- QR Code -->
                    <div class="text-center mb-3">
                        <div v-if="loadingQr" class="py-4">
                            <i class="fa fa-spinner fa-spin fa-2x text-primary"></i>
                        </div>
                        <div v-else>
                            <!-- Usa qrcode.vue oppure un servizio di generazione QR -->
                            <img
                                :src="qrImageUrl"
                                alt="QR Code 2FA"
                                style="width:200px;height:200px;border:1px solid #dee2e6;border-radius:8px;"
                            />
                            <p class="mt-2 font-size-sm text-muted">
                                Non riesci a scansionare?<br>
                                Inserisci manualmente questo codice nell'app:<br>
                                <code class="d-block mt-1 font-size-sm">{{ secretLeggibile }}</code>
                            </p>
                        </div>
                    </div>

                    <!-- Input OTP di conferma -->
                    <ValidationObserver ref="observerQr" v-slot="{ invalid }">
                        <div class="form-group">
                            <label><strong>Conferma con il codice OTP</strong></label>
                            <ValidationProvider rules="required|digits:6" name="Codice OTP" v-slot="{ errors }">
                                <input
                                    v-model="otpConferma"
                                    type="text"
                                    class="form-control text-center font-size-h5"
                                    placeholder="000000"
                                    maxlength="6"
                                    inputmode="numeric"
                                    autocomplete="one-time-code"
                                >
                                <span class="validation-error">{{ errors[0] }}</span>
                            </ValidationProvider>
                        </div>
                        <p v-if="erroreConferma" class="text-danger">
                            <i class="fa fa-exclamation-circle mr-1"></i>{{ erroreConferma }}
                        </p>
                        <div class="d-flex">
                            <button @click="annullaSetup" type="button" class="btn btn-light mr-2">
                                Annulla
                            </button>
                            <button
                                :disabled="invalid || loadingConferma"
                                @click="conferma2fa"
                                type="button"
                                class="btn btn-success"
                            >
                                <i v-if="loadingConferma" class="fa fa-spinner fa-spin mr-1"></i>
                                <i v-else class="fa fa-check mr-1"></i>
                                Attiva 2FA
                            </button>
                        </div>
                    </ValidationObserver>
                </div>

                <!-- =====================================================
                     STATO: 2FA ATTIVO
                ====================================================== -->
                <div v-if="twoFactorAbilitato && stepSetup === 'idle'">
                    <div class="text-center mb-4">
                        <i class="fa fa-shield-alt fa-4x text-success mb-3"></i>
                        <h4>2FA attivo</h4>
                        <p class="text-muted">
                            Il tuo account è protetto con l'autenticazione a due fattori tramite
                            <strong>Microsoft Authenticator</strong> o <strong>Google Authenticator</strong>.
                        </p>
                    </div>

                    <!-- Form disabilitazione -->
                    <!-- <div class="block block-rounded border border-danger"> 
                        <div class="block-header block-header-default">
                            <h5 class="block-title text-danger">
                                <i class="fa fa-exclamation-triangle mr-1"></i> Disabilita 2FA
                            </h5>
                        </div>
                        <div class="block-content">
                            <p class="text-muted font-size-sm mb-3">
                                Per disabilitare il 2FA inserisci la tua password attuale come conferma.
                            </p>
                            <ValidationObserver ref="observerDisabilita" v-slot="{ invalid }">
                                <div class="form-group">
                                    <label>Password attuale</label>
                                    <ValidationProvider rules="required" name="Password" v-slot="{ errors }">
                                        <input
                                            v-model="passwordDisabilita"
                                            type="password"
                                            class="form-control"
                                            placeholder="Inserisci la tua password"
                                        >
                                        <span class="validation-error">{{ errors[0] }}</span>
                                    </ValidationProvider>
                                </div>
                                <p v-if="erroreDisabilita" class="text-danger">
                                    <i class="fa fa-exclamation-circle mr-1"></i>{{ erroreDisabilita }}
                                </p>
                                <button
                                    :disabled="invalid || loadingDisabilita || 1"
                                    @click="disabilita2fa"
                                    type="button"
                                    class="btn btn-danger"
                                >
                                    <i v-if="loadingDisabilita" class="fa fa-spinner fa-spin mr-1"></i>
                                    <i v-else class="fa fa-times mr-1"></i>
                                    Disabilita 2FA
                                </button>
                            </ValidationObserver>
                        </div>
                    </div>
                    -->
                </div>

            </div>
        </div>
    </div>
</template>

<script>
import AuthenticationRepository from '../../services/apis/authentication'

export default {
    props: {
        user: { type: Object, default: null }
    },
    data() {
        return {
            // 'idle' | 'qr'
            stepSetup: 'idle',

            // Setup
            qrImageUrl:      '',
            secretLeggibile: '',
            otpConferma:     '',
            erroreConferma:  '',
            loadingQr:       false,
            loadingConferma: false,

            // Disabilita
            passwordDisabilita: '',
            erroreDisabilita:   '',
            loadingDisabilita:  false,
        }
    },
    computed: {
        // Il backend restituisce two_factor_secret solo se presente (non null)
        // Se la prop user ha il campo, il 2FA è attivo.
        twoFactorAbilitato() {
            console.log('ciao', this.user)
            return this.user && !!this.user.two_factor_enabled
        }
    },
    methods: {
        // ------------------------------------------------------------------
        // Avvia il setup: chiama il backend per ottenere secret + QR URL
        // ------------------------------------------------------------------
        async avviaSetup() {
            this.loadingQr = true
            this.stepSetup = 'qr'

            const resp = await AuthenticationRepository.setup2fa().catch(() => null)
            this.loadingQr = false

            if (!resp || resp.data.status !== 'success') {
                this.$toasted.error('Errore durante la generazione del QR. Riprova.').goAway(3000)
                this.stepSetup = 'idle'
                return
            }

            this.secretLeggibile = resp.data.data.secret
            // Usa l'URL restituito dal backend per generare il QR tramite un
            // servizio gratuito (nessuna dipendenza npm aggiuntiva).
            // Se preferisci usare qrcode.vue, passa resp.data.data.qr_code_url
            // direttamente al componente <qrcode-vue :value="...">
            this.qrImageUrl = `https://api.qrserver.com/v1/create-qr-code/?size=200x200&data=${encodeURIComponent(resp.data.data.qr_code_url)}`
        },

        // ------------------------------------------------------------------
        // Conferma il setup con il primo codice OTP
        // ------------------------------------------------------------------
        async conferma2fa() {
            this.erroreConferma  = ''
            this.loadingConferma = true

            const resp = await AuthenticationRepository.confirm2fa({ otp_code: this.otpConferma }).catch(() => null)
            this.loadingConferma = false

            if (!resp || resp.data.status !== 'success') {
                this.erroreConferma = resp?.data?.message || 'Codice OTP non valido. Riprova.'
                this.otpConferma    = ''
                return
            }

            this.$toasted.success('2FA abilitato con successo!').goAway(3000)
            this.stepSetup   = 'idle'
            this.otpConferma = ''
            this.$emit('callbackReload')   // ricarica i dati utente in Profilo.vue
        },

        // ------------------------------------------------------------------
        // Annulla il setup
        // ------------------------------------------------------------------
        annullaSetup() {
            this.stepSetup       = 'idle'
            this.otpConferma     = ''
            this.erroreConferma  = ''
            this.qrImageUrl      = ''
            this.secretLeggibile = ''
        },

        // ------------------------------------------------------------------
        // Disabilita il 2FA
        // ------------------------------------------------------------------
        async disabilita2fa() {
            this.erroreDisabilita  = ''
            this.loadingDisabilita = true

            const resp = await AuthenticationRepository.disable2fa({ password: this.passwordDisabilita }).catch(() => null)
            this.loadingDisabilita = false

            if (!resp || resp.data.status !== 'success') {
                this.erroreDisabilita = resp?.data?.message || 'Errore. Controlla la password e riprova.'
                return
            }

            this.$toasted.success('2FA disabilitato.').goAway(3000)
            this.passwordDisabilita = ''
            this.$emit('callbackReload')
        },
    }
}
</script>